module.exports = __webpack_public_path__ + "static/media/mail.d41d8cd9.svg";